import React, { useEffect, useState } from 'react';
import { POST_LIKES_MODAL } from '../../context/general/constants';
import { useGeneralDispatch, useGeneralState } from '../../context/general/generalContext';
import images from '../../assets/images';
import { useRequest } from '../../hooks/useRequest';
const PostLikesModal = () => {
  const { request } = useRequest();
  const dispatch = useGeneralDispatch();
  const { postLikesModal } = useGeneralState();
  const [likes, setLikes] = useState([]);

  useEffect(() => {
    console.log(postLikesModal);
    if (postLikesModal.open) {
      if (postLikesModal.isPostLike) {
        request('post/getPostLikes', {
          method: 'GET',
          params: {
            postId: postLikesModal.id
          }
        }).then((res) => {
          setLikes(res.data.result);
        });
      } else {
        request('post/getCommentLikes', {
          method: 'GET',
          params: {
            postId: postLikesModal.id,
            commentId: postLikesModal.commentId
          }
        }).then((res) => {
          setLikes(res.data.result);
        });
      }
    }
  }, [postLikesModal]);

  const closeModal = () => {
    dispatch({
      type: POST_LIKES_MODAL,
      payload: {
        open: false,
        isPostLike: true,
        id: null
      }
    });
  };
  return (
    <div className="post-container-likeModal">
      {' '}
      <div className="post-container-likeModal--content">
        <div className="post-container-likeModal--content--closeHeader">
          {' '}
          <img
            onClick={closeModal}
            className="post-container-likeModal--content--closeHeader--close"
            src={images.iconClose}
            alt="Close Icon"
            data-modal-close="data-modal-close"
          />{' '}
          <div className="post-container-likeModal--content--closeHeader--text"> Beğenenler </div>
        </div>
        <div className="post-container-likeModal--content--list">
          {likes?.map((p, key) => (
            <div key={key} className="post-container-likeModal--content--list--item">
              <img
                className="post-container-title-bottom-timer"
                src={p.profilePhoto}
                style={{ width: '40px', height: '40px' }}
                alt=""
              />
              <p className="post-container-likeModal--content-pStyle">{p.owner} </p>
            </div>
          ))}
          <p className="post-container-likeModal--footer">{likes.length} Kişi Beğendi</p>{' '}
        </div>
      </div>
    </div>
  );
};

export default PostLikesModal;
